import { isRussia, isUS } from 'env'
import { refetchFunc } from 'modules/domain/common/hooks'
import { Company, USCompany } from 'modules/domain/company/types'
import { FC } from 'react'
import { EditWorldCompany } from '../WorldModals/EditWorldCompany'
import { USEditCompanyModal } from '../components/USCompanyModals/USEditCompanyModal'
import { CompanyRuEdit } from './CompanyGeneral/CompanyRuEdit'

type Props = {
  setCompanyEditModalOpen: (payload: boolean) => void
  refreshCompany: refetchFunc | (() => void)
  company: Company | USCompany
}

export const EditCompanyControl: FC<Props> = ({ setCompanyEditModalOpen, company, refreshCompany }) => {
  if (isRussia) {
    return (
      <CompanyRuEdit
        onClose={() => setCompanyEditModalOpen(false)}
        refreshCompany={refreshCompany}
        company={company as Company}
      />
    )
  }

  if (isUS) {
    return (
      <USEditCompanyModal
        onClose={() => setCompanyEditModalOpen(false)}
        company={company as USCompany}
        onSuccess={refreshCompany}
      />
    )
  }

  return (
    <EditWorldCompany
      refreshCompany={refreshCompany}
      company={company as Company}
      onClose={() => setCompanyEditModalOpen(false)}
    />
  )
}
